import I18n from "i18n-js"
import { removeHtmlElementClass, addHtmlElementClass } from "../../utils/utils"
import { useEffect, useState } from "react"


const SaleItemDeletedHappyEnding = ({
    saleItem,
    handleCloseDeletedSaleItemNotice,
    handleCloseDeletedSaleItemAnimation
}) => {

    const HappyDeletedEndingInstructions = ({
        saleItem,
        containerCSSClasses
    }) => {
        return (
            <div className={`row w-100 pl-3 pl-lg-0 ${containerCSSClasses}`}>
                <div className="col-12 col-sm-6 col-md-4 text-sm-center text-md-left pt-3">
                    <div className="text-aig-gradient-strong text-weight-500 font-size-14px">
                        {I18n.t('js.indexSaleItems.happyDeletedEnding.section1Title').replaceAll(':sale_channel', saleItem.sale_channel.meta_name).toUpperCase()}
                    </div>
                    <p className="mt-1">
                        {I18n.t('js.indexSaleItems.happyDeletedEnding.section1Description').replaceAll(':sale_channel', saleItem.sale_channel.meta_name)}
                    </p>
                </div>
                <div className="col-12 col-sm-6 col-md-4 text-sm-center text-md-left pt-3">
                    <div className="text-aig-gradient-strong text-weight-500 font-size-14px">
                        {I18n.t('js.indexSaleItems.happyDeletedEnding.section2Title').replaceAll(':sale_channel', saleItem.sale_channel.meta_name).toUpperCase()}
                    </div>
                    <p className="mt-1">
                        {I18n.t('js.indexSaleItems.happyDeletedEnding.section2Description').replaceAll(':sale_channel', saleItem.sale_channel.meta_name)}
                    </p>
                </div>

                <div className="col-12 col-sm-6 col-md-4 text-sm-center text-md-left pt-3">
                    <div className="text-aig-gradient-strong text-weight-500 font-size-14px">
                        {I18n.t('js.indexSaleItems.happyDeletedEnding.section3Title').replaceAll(':sale_channel', saleItem.sale_channel.meta_name).toUpperCase()}
                    </div>
                    <p className="mt-1">
                        {I18n.t('js.indexSaleItems.happyDeletedEnding.section3Description').replaceAll(':sale_channel', saleItem.sale_channel.meta_name)}
                    </p>
                </div>
            </div>
        )
    }



    return (
        <div id={`fade-out-${saleItem.id}-deleted`}>
            <div className="row w-100 px-0 mx-0 mt-2px">
                <div className="col-12 col-sm-5 col-md-4 col-lg-3 d-flex justify-content-center align-items-end py-4 py-xl-0">
                    <img src="/images/listing-deleted-happy-ending.svg" alt="happy-ending" width="220px" style={{maxHeight: "200px"}}/>
                </div>

                <div className="col-12 col-sm-7 col-md-8 col-lg-9 d-flex justify-content-center justify-content-lg-start flex-column pt-0 pt-lg-4 pt-xl-5 pb-2">
                    <div className="pb-2">
                        <div className="text-aig-gradient">
                            <h3 className="my-0"><b>{I18n.t('js.indexSaleItems.happyDeletedEnding.title')}</b></h3>
                        </div>
                        <h4 className="text-semi-black mt-2 mb-0">{I18n.t('js.indexSaleItems.happyDeletedEnding.subTitle').replace(':sale_channel', saleItem.sale_channel.meta_name)}</h4>
                    </div>

                    <HappyDeletedEndingInstructions
                        saleItem={saleItem}
                        containerCSSClasses={"d-none d-lg-flex flex-wrap justify-content-center"}
                    />
                </div>

                <HappyDeletedEndingInstructions
                    saleItem={saleItem}
                    containerCSSClasses={"d-flex flex-wrap justify-content-center d-lg-none"}
                />
            </div>
            <div className="d-flex justify-content-center text-center w-100 py-3">
                <span className="text-aiBlue cursor-pointer m-0 p-0" onClick={() => {
                    handleCloseDeletedSaleItemAnimation(saleItem)
                    setTimeout(() => {
                        handleCloseDeletedSaleItemNotice(saleItem)
                    }, 350);
                }}>
                    {I18n.t('js.indexSaleItems.happyDeletedEnding.closing')}
                </span>
            </div>
        </div>
    )
}

export default SaleItemDeletedHappyEnding